import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { SellerItemUi } from '@/components/Seller/Table/SellerUi';
import COLORS from '@/constants/colors';
import { SellerResponse } from '@/data/api/model/sellers/SellersDto';

export const sellerResponseToSellerItemUi = (
  item: SellerResponse
): SellerItemUi => {
  return {
    id: item.business_id,
    sellerName: item.account_name,
    accountName: item.business_name,
    email: item.email,
    phone: item.phone,
    status: sellerStatusToStatusBadgeUi(item.business_status),
  };
};

export const sellerStatusToStatusBadgeUi = (
  status: string
): statusBadgeUi | undefined => {
  switch (status) {
    case 'INACTIVE':
      return {
        statusId: status,
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: 'Inactivo',
      };
    case 'ACTIVE':
      return {
        statusId: status,
        textColor: COLORS.success_700,
        backgroundColor: COLORS.success_50,
        edgeColor: COLORS.success_200,
        text: 'Activo',
      };
  }
};
